import { prepareBudgetPush } from '../server/row-scope-remote'

export const replicaRequestBytes = 4 * 1024 * 1024 + 1024

/** Keep frozen transaction identity; send only its empty header/digest/count above the body limit. */
export async function sendBudgetedPush(bytes: Uint8Array, send: (bytes: Uint8Array) => Promise<Uint8Array>, requestBytes = replicaRequestBytes): Promise<Uint8Array> {
  const prepared = await prepareBudgetPush(bytes, requestBytes)
  const response = await send(prepared.bytes)
  return prepared.restore(response)
}
